import { render, staticRenderFns } from "./MenuUpdate.vue?vue&type=template&id=98add110&"
import script from "./MenuUpdate.vue?vue&type=script&lang=js&"
export * from "./MenuUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports